function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import * as React from "react";
var Support = function Support(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size || 16,
    height: props.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: props.size > 16 ? 0 : 0.8,
    stroke: props.size <= 16 ? props.color ? props.color : "#242328" : "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color || "#222222",
    fillRule: "evenodd",
    d: "M2.75 5c0-.69.56-1.25 1.25-1.25h16c.69 0 1.25.56 1.25 1.25v14.92a.25.25 0 0 1-.406.195l-2.828-2.262a2.75 2.75 0 0 0-1.718-.603H4c-.69 0-1.25-.56-1.25-1.25zM4 2.25A2.75 2.75 0 0 0 1.25 5v11A2.75 2.75 0 0 0 4 18.75h12.298c.284 0 .56.097.781.274l2.828 2.262c1.146.917 2.843.1 2.843-1.367V5A2.75 2.75 0 0 0 20 2.25zm4.604 9.306a.75.75 0 1 0-1.208.889c.895 1.215 2.654 1.89 4.353 1.966 1.723.078 3.638-.445 4.837-1.942a.75.75 0 0 0-1.172-.937c-.801 1.002-2.174 1.445-3.597 1.38-1.444-.064-2.685-.64-3.213-1.357M8.25 9.5a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5M17 8.25a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0",
    clipRule: "evenodd"
  }));
};
export default Support;
Support.displayName = 'Support';